import React from 'react'
import { cn } from '@kiao-voice/ui-kit'

/**
 * 示範下方的「①②③ 小標＋一句說明」。三個產品頁共用，一律放在示範**下方**。
 *
 * 小標與說明是 `--font-body`（16px 600／15px 1.65），不是襯線：這兩行是行文不是
 * 標題，進襯線 subset 只會把字集撐大，漏字時還會在同一段裡混兩套字。
 */

export interface HowListItem {
  title: string
  description: string
}

export interface HowListProps {
  items: HowListItem[]
  /** `grid` 三欄、上緣髮絲線（接在示範框下）；`stack` 直排、無上緣線（側欄用）。 */
  variant?: 'grid' | 'stack'
  /** 補充一行，同字級、淡字、不編號。 */
  note?: React.ReactNode
  className?: string
}

export function HowList({ items, variant = 'grid', note, className }: HowListProps) {
  return (
    <div className={className}>
      <ol
        className={cn(
          'list-none p-0',
          variant === 'grid' &&
            'mt-(--gap-lg) grid grid-cols-3 gap-(--gap-lg) border-t border-line-soft pt-(--gap-lg) max-[720px]:grid-cols-1 max-[720px]:gap-(--gap-md)',
          variant === 'stack' && 'm-0 grid grid-cols-1 gap-(--gap-md)'
        )}
      >
        {items.map((item, index) => (
          <li key={item.title} className="grid grid-cols-[22px_minmax(0,1fr)] items-start gap-3">
            <span
              aria-hidden="true"
              className="mt-px grid size-[22px] place-items-center rounded-full border border-foreground font-mono text-2xs leading-none"
            >
              {index + 1}
            </span>
            <div>
              <h3 className="mb-1.5 text-lg leading-[1.5] font-semibold">{item.title}</h3>
              <p className="text-md leading-[1.65] text-muted">{item.description}</p>
            </div>
          </li>
        ))}
      </ol>
      {note ? <p className="mt-(--gap-md) text-md leading-[1.65] text-muted">{note}</p> : null}
    </div>
  )
}
